import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppointmentsEffects } from './+state/appointments/appointments.effects';
import { FixedOperationsEffects } from './+state/fixed-operations.effects';
import { appReducer } from './+state/fixed-operations.reducer';
import { WorkOrdersEffects } from './+state/work-orders/work-orders.effects';
import { QuotesEffects } from './+state/quotes/quotes.effects';
import { FixedOperationsStateService } from './fixed-operations-state.service';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('fixedOperations', appReducer, {}),
    EffectsModule.forFeature([FixedOperationsEffects, AppointmentsEffects, WorkOrdersEffects, QuotesEffects])
  ],
  providers: [FixedOperationsEffects, AppointmentsEffects, FixedOperationsStateService, WorkOrdersEffects]
})
export class XsrFixedOperationsModule {}
